import { useEffect, useRef, useState, type ReactElement } from 'react'
import { voiceEnglish, type VoiceText } from './voice-text'
import { AudioPlayer } from './AudioPlayer'
const english = (key: VoiceText): string => voiceEnglish[key]

export function VoiceMessage({ load, durationMs, text = english }: {
  load: () => Promise<Blob>; durationMs: number; text?: (key: VoiceText) => string
}): ReactElement {
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const alive = useRef(true)
  useEffect(() => { alive.current = true; return () => { alive.current = false } }, [])
  useEffect(() => () => { if (url) URL.revokeObjectURL(url) }, [url])
  const open = async () => {
    setLoading(true); setError(false)
    try {
      const blob = await load()
      if (alive.current) setUrl(URL.createObjectURL(blob))
    } catch { if (alive.current) setError(true) }
    finally { if (alive.current) setLoading(false) }
  }
  const seconds = Math.ceil(durationMs / 1000)
  return <div className="support-voice space-y-2" data-loaded={Boolean(url)}>
    {url ? <AudioPlayer key={url} src={url} label={text('play')} durationMs={durationMs} autoPlay text={text} /> : <button type="button" className="support-voice-load" disabled={loading} onClick={() => { void open() }}>
      <span className="support-voice-icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="m8 5 11 7-11 7Z" /></svg></span>
      <span className="min-w-0 flex-1 text-start"><span className="block text-sm font-medium">{text(loading ? 'loading' : 'play')}</span><span className="block text-xs opacity-75">{Math.floor(seconds / 60)}:{String(seconds % 60).padStart(2, '0')}</span></span>
      <svg aria-hidden="true" className="support-audio-icon" width="52" height="24" viewBox="0 0 52 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><path d="M3 9v6m7-11v16m7-13v10m7-15v20m7-17v14m7-11v8m7-5v2" /></svg>
    </button>}
    {error && <p role="alert" className="text-xs">{text('loadFailed')}</p>}
  </div>
}
